<bz-button appBringozIdGenerator="bringozTimePickerBtn"
           variant="tertiary"
           ariaLabel="Time picker"
           [disabled]="isDisabled()"
           (clicked)="openDialog($event)">
  <span class="layout-row layout-align-start-center">
    <bz-icon class="margin-right-5" [icon]="icon"></bz-icon>
    @if (range()) {
      <span class="br-body-2">{{ range() | bringozTime: 'dateStart' }} - {{ range() | bringozTime: 'dateEnd' }}</span>
    } @else {
      <span>Time Filter</span>
    }
  </span>
</bz-button>
